/**
 * @file hooks/actions
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import {useDispatch} from 'react-redux';
import {useMemo, DependencyList} from 'react';
import {bindActionCreators} from 'redux';

export default (actions: any, deps?: DependencyList[]) => {
    const dispatch = useDispatch();

    return useMemo(() => {
        if (Array.isArray(actions)) {
            return actions.map(a => bindActionCreators(a, dispatch));
        }
        return bindActionCreators(actions, dispatch);
    }, deps ? [dispatch, ...deps] : [dispatch]);
};
